import React from "react";
import { useSelector } from "react-redux";


// Scss
import "./ProjectsPerformanceDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import APIcon from "assets/icons/ap-icon.svg";
import CostValueIcon from "assets/icons/cost-value.svg";
import PieSlicesIcon from "assets/icons/pie-slices.svg";
import WalletIcon from "assets/icons/wallet.svg";
import WalletIconLight from "assets/icons/wallet-light.svg";
import ConstructionProjectsIcon from "assets/icons/construction-new.svg";
import RenovationProjectsIcon from "assets/icons/renovation-new.svg";
import TransformationProjectsIcon from "assets/icons/transformation-new.svg";
import HeartIcon from "assets/icons/heart-new.svg";
import ProjectsPerformanceIcon from "assets/icons/projects-performance.svg";
import ProjectsPerformanceIconLight from "assets/icons/projects-performance-light.svg";
import NoteWhiteIcon from "assets/icons/note-white.svg";
import NoteWhiteIconLight from "assets/icons/note-white-light.svg";
import PBBIcon from "assets/icons/wallet-sm.svg";
import TTCIcon from "assets/icons/ttc.svg";
import TTCIconLight from "assets/icons/ttc-light.svg";
import CalendarSmallIcon from "assets/icons/calendar-small.svg";

// Importing Components
import SmallPie from "components/charts/SmallPie";
import StackedChart from "components/charts/StackedCharts";

// Importing Packages
import "animate.css";

function ProjectsPerformanceDashboard() {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);

  return (
    <>
     {/* Dropdowns Wrapper */}
     <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Ahead Projects Pane */}
      <section className="ahead-projects-wrapper">
        <div className="ahead-projects-container">
          <div className="cp-title">
            <img src={APIcon} alt="#" />
            <span>Ahead Projects</span>
          </div>
          <div className="cp-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice And Right Section Slice Info */}
      <section className="grid-wrapper-pp">
        <div className="left-section-container">
          <div className="top">
            <div className="info">
              <div className="budget-revised">
                <div className="budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span className="budget-light">Budget</span>
                  </div>
                  <div className="information">
                    <span className="revised">33,597</span>
                    <span className="budget-sar">SAR</span>
                  </div>
                </div>
                <div className="revised-budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span className="budget-light">
                      Revised <br />
                      Budget
                    </span>
                  </div>
                  <div className="information">
                    <span className="revised">33,597</span>
                    <span className="budget-sar">SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="e-p-costvalue">
                <div className="p-cost-value blank">
                  <div className="icon-container">
                    <img src={CostValueIcon} alt="#" />
                    <span>
                      Planed Cost <br /> Value
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
                <div className="e-cost-value blank">
                  <div className="icon-container">
                    <img src={CostValueIcon} alt="#" />
                    <span>
                      Earned Cost <br /> Value
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="pie-info">
                <div className="icon-container">
                  <img src={PieSlicesIcon} alt="#" />
                </div>
                <span>SPI</span>
                <div className="chart">
                  <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                  <span>45%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="middle-section-container">
          <div className="head">
            <span>
            {selectedTheme === "dark" ? (
                <img src={ProjectsPerformanceIcon} alt="#" />
              ) : (
                <img src={ProjectsPerformanceIconLight} alt="#" />
              )}
              Project Performance Status
            </span>
          </div>
          <div className="body">
          <div className="chart-container">
            <div className="chart-wrapper">
              <div className="vertical-bar-container">
                <div className="chart-system">
                  <span className="code gray">#</span>
                  <span className="currency white">SAR</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage gray">70%</span>
                  <div className="bar">
                    <div className="progress gray" style={{ height: "70%" }}>
                      <div className="glow gray"></div>
                    </div>
                  </div>
                  <span className="value gray">272</span>
                  <span className="amount white">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage red">6%</span>
                  <div className="bar">
                    <div className="progress red" style={{ height: "6%" }}>
                      <div className="glow red"></div>
                    </div>
                  </div>
                  <span className="value gray">272</span>
                  <span className="amount white">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage blue">6%</span>
                  <div className="bar">
                    <div className="progress blue" style={{ height: "6%" }}>
                      <div className="glow blue"></div>
                    </div>
                  </div>
                  <span className="value gray">272</span>
                  <span className="amount white">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage green">45%</span>
                  <div className="bar">
                    <div className="progress green" style={{ height: "45%" }}>
                      <div className="glow green"></div>
                    </div>
                  </div>
                  <span className="value gray">272</span>
                  <span className="amount white">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">  
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage orange">20%</span>
                  <div className="bar">
                    <div className="progress orange" style={{ height: "20%" }}>
                      <div className="glow orange"></div>
                    </div>
                  </div>
                  <span className="value gray">272</span>
                  <span className="amount white">14191.57M</span>
                </div>
              </div>
              
            </div>
          </div>
          </div>
        </div>
        <div className="right-section-container">
        <div className="head">
            <span>
            {selectedTheme === "dark" ? (
                <img src={NoteWhiteIcon} alt="#" />
              ) : (
                <img src={NoteWhiteIconLight} alt="#" />
              )}
              Projects By Cluster
            </span>
          </div>
          <div className="body">
          <div className="chart-container">
            <div className="chart-wrapper">
              <div className="vertical-bar-container">
                <div className="chart-system">
                  <span className="code">#</span>
                  <span className="currency">SAR</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage">70%</span>
                  <div className="bar">
                    <div className="progress" style={{ height: "70%" }}>
                      <div className="glow"></div>
                    </div>
                  </div>
                  <span className="value">272</span>
                  <span className="amount">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage">70%</span>
                  <div className="bar">
                    <div className="progress" style={{ height: "70%" }}>
                      <div className="glow"></div>
                    </div>
                  </div>
                  <span className="value">272</span>
                  <span className="amount">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage">70%</span>
                  <div className="bar">
                    <div className="progress" style={{ height: "70%" }}>
                      <div className="glow"></div>
                    </div>
                  </div>
                  <span className="value">272</span>
                  <span className="amount">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage">70%</span>
                  <div className="bar">
                    <div className="progress" style={{ height: "70%" }}>
                      <div className="glow"></div>
                    </div>
                  </div>
                  <span className="value">272</span>
                  <span className="amount">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage">70%</span>
                  <div className="bar">
                    <div className="progress" style={{ height: "70%" }}>
                      <div className="glow"></div>
                    </div>
                  </div>
                  <span className="value">272</span>
                  <span className="amount">14191.57M</span>
                </div>
              </div>
              <div className="vertical-bar-container">
                <div className="label">
                  <span>Label</span>
                </div>
                <div className="stand-bar">
                  <span className="percentage">70%</span>
                  <div className="bar">
                    <div className="progress" style={{ height: "70%" }}>
                      <div className="glow"></div>
                    </div>
                  </div>
                  <span className="value">272</span>
                  <span className="amount">14191.57M</span>
                </div>
              </div>
              
            </div>
          </div>
          </div>
        </div>
      </section>

      {/* Projects Progress Graph Section */}
      <section className="projects-progress-graph-wrapper">
        <div className="projects-progress-graph-container">
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info darkblue">
              <div className="head">
                <span>
                  <img src={ConstructionProjectsIcon} alt="#" />
                  Construction Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalgreen"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalgreen">
              <div className="head">
                <span>
                  <img src={RenovationProjectsIcon} alt="#" />
                  Renovation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white wastewater">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white wastewater">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalorange"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalorange">
              <div className="head">
                <span>
                  <img src={TransformationProjectsIcon} alt="#" />
                  Transformation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white tse">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white tse">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalblue">
              <div className="head">
                <span>
                  <img src={HeartIcon} alt="#" />
                  Supportive Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects By Contractors / Budgets Section */}
      <section className="project-budgets-contractors-wrapper">
        <div className="project-budgets-contractors-container">
          <div className="left">
            <div className="head">
              <span>
                {selectedTheme === 'dark'? <img src={PBBIcon} alt="#" />: <img src={WalletIconLight} alt="#" />}
               
                Project By Budgets
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Project Name</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                      <td>123,342,344</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
               {selectedTheme === 'dark'? <img src={TTCIcon} alt="#" />: <img src={TTCIconLight} alt="#" />}
                Project By Contractors
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Contractors</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                    </tr>
                    <tr>
                      <td>ﺎﻬﺒﻜﺗرا ﻒﻴﻟﺎﻜﺗ مﺪﻋ نأ .ﻞﺒﻗ ـﺑ دﺎﺘﻌﻟاو طﻮﻐﻀﻟا</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="projects-Performance-info-wrapper">
        <div className="projects-Performance-info-container">
          <div className="left">
            <div className="head">
              <span>
              {selectedTheme === "dark" ? (
                <img src={ProjectsPerformanceIcon} alt="#" />
              ) : (
                <img src={ProjectsPerformanceIconLight} alt="#" />
              )}
               Project Performance
              </span>
            </div>
            <div className="body">
              <div className="chart-container">
                <div className="chart">
                  {
                    selectedTheme === 'dark'?
                    <StackedChart
                    data={{
                      categories: [
                        "JAN 2022",
                        "FEB 2022",
                        "MAR 2022",
                        "APR 2022",
                        "MAY 2022",
                        "JUN 2022",
                        "JUL 2022",
                        "AUG 2022",
                        "SEP 2022",
                        "OCT 2022",
                        "NOV 2022",
                        "DEC 2022",
                      ],
                      data: [
                        [
                          37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                          35.9, 42.7,
                        ],
                        [
                          37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                          35.9, 42.7,
                        ],
                      ],
                    }}
                    colorset={{
                      firstSet: [
                        "rgba(233, 99, 28, 0.5)",
                        "rgba(39, 44, 47, 1)",
                      ],
                      secondSet: [
                        "rgba(35, 157, 156, 0.5)",
                        "rgba(39, 44, 47, 1)",
                      ],
                    }}
                    linecolor={"#272C2F"}
                    label={"#f1f2f3"}
                  />:
                  <StackedChart
                    data={{
                      categories: [
                        "JAN 2022",
                        "FEB 2022",
                        "MAR 2022",
                        "APR 2022",
                        "MAY 2022",
                        "JUN 2022",
                        "JUL 2022",
                        "AUG 2022",
                        "SEP 2022",
                        "OCT 2022",
                        "NOV 2022",
                        "DEC 2022",
                      ],
                      data: [
                        [
                          37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                          35.9, 42.7,
                        ],
                        [
                          37.8, 20.3, 40.8, 36.8, 40.5, 35.3, 34.9, 43.6, 45.7,
                          35.9, 42.7,
                        ],
                      ],
                    }}
                    colorset={{
                      firstSet: [
                        "rgba(233, 99, 28, 0.5)",
                        "rgba(39, 44, 47, 1)",
                      ],
                      secondSet: [
                        "rgba(35, 157, 156, 0.5)",
                        "rgba(39, 44, 47, 1)",
                      ],
                    }}
                    linecolor={"#f1f2f3"}
                    label={"#424B51"}
                  />
                  }
                  
                </div>
                <div className="chart-info">
                  <div className="tile">
                     
                  </div>
                  <div className="tile">
                    <img src={CalendarSmallIcon} alt="#" />
                    <span>Start Date</span>
                    <span>16-Jan-2022</span>
                  </div>
                  <div className="tile">
                    <img src={CalendarSmallIcon} alt="#" />
                    <span>Finish Date</span>
                    <span>16-Jan-2022</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <div className="head">
              <span>
              {selectedTheme === 'dark'? <img src={TTCIcon} alt="#" />: <img src={TTCIconLight} alt="#" />}
              Projects By Contractor
              </span>
            </div>
            <div className="body">
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>Year</th>
                      <th># Of Projects</th>
                      <th>Budget (SAR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2019</td>
                      <td>5</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2020</td>
                      <td>3</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2021</td>
                      <td>8</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2022</td>
                      <td>10</td>
                      <td>123,345</td>
                    </tr>
                    <tr>
                      <td>2023</td>
                      <td>4</td>
                      <td>123,345</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectsPerformanceDashboard;
